module.exports = require("commander");


//////////////////
// WEBPACK FOOTER
// external "commander"
// module id = 21
// module chunks = 0